import { createQueryKeys } from '@lukemorales/query-key-factory'

export const partnerMatch = createQueryKeys('partnerMatch', {
  thisWeek: null,
  list: (limit: number, skip: number) => [limit, skip],
  detail: (matchId: number) => [matchId],
  preferences: null,
})
